export default "/images/vendor/@coreui/icons/svg/flag/cif-ec.svg?ecc9c6af7802228bb84cc75a7cb6b73f";